import React from 'react'

export default function Footer() {
  return (
  <div className="footer-wrapper bg-darkblack" style={{marginTop: 50}}>
  <div className="container">
    <div className="row posr">
      <div className="col-12 posa top-0 start-50 translate-middle">
        <div className="subscribe-banner rounded-10 bg-current p-md-5 p-4">
          <div className="row">
            <div className="col-lg-6 col-md-6"><h2 className="h1 text-uppercase text-gray-white rajdhani-700 lh-1 m-0">Subsribe to our <br />newsletter</h2></div>
            <div className="col-lg-5 col-md-6 md-mt-3 ms-auto mt-3">
              <form action="#">
                <div className="row">
                  <div className="col-8 pe-0"><input type="text" className="form-control form-control-lg bg-dark border-0 rounded-0" placeholder="Enter your email address" /></div>
                  <div className="col-4 ps-0"><button className="text-gray-900 text-uppercase rajdhani-700 font-sm form-control rounded-0 form-control-lg border-0 w-100">Submit</button></div>	
                </div>		
              </form>	
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="row pt-151">
      <div className="col-lg-4 col-md-10 col-12 mt-0">
        <a className="navbar-brand" href="/"><img src="images/logo/avatarlab.jpg" alt="avatarlab" /></a>
        <p className="mt-3 mb-4 pe-4 rajdhani-600 font-sm lh-24 text-white ">A unified hub connecting Meta enthusiasts, game developers, and Avatar creators, fostering collaboration and innovation.</p>
        <ul className="list-group flex-row gap-3 social-icon">
          <li className="list-group-item p-0 bg-transparent border-0"><a href="#" className="btn-icon bg-transparent rounded-0 btn btn-md btn-icon border-dark border-2"><i className="bi-twitch text-gray-300 font-md m-0" /></a></li>
          <li className="list-group-item p-0 bg-transparent border-0"><a href="#" className="btn-icon bg-transparent rounded-0 btn btn-md btn-icon border-dark border-2"><i className="bi-linkedin text-gray-300 font-md m-0" /></a></li>
          <li className="list-group-item p-0 bg-transparent border-0"><a href="#" className="btn-icon bg-transparent rounded-0 btn btn-md btn-icon border-dark border-2"><i className="bi-twitter text-gray-300 font-md m-0" /></a></li>
        </ul>
      </div>
      <div className="col-lg-2 col-md-4 col-6 lg-mt-3 ms-auto">
        <h4 className="text-white h6 rajdhani-700 mb-4 mt-1 text-uppercase">For Developers</h4>
        <ul className="list-group gap-2">
          <li className="list-group-item bg-transparent border-0 p-0"><a href="#" className="rajdhani-600 text-gray-100 font-sm">Documentation</a></li>
          <li className="list-group-item bg-transparent border-0 p-0"><a href="#" className="rajdhani-600 text-gray-100 font-sm">Sign up as a Developer</a></li>
          <li className="list-group-item bg-transparent border-0 p-0"><a href="#" className="rajdhani-600 text-gray-100 font-sm">SDK</a></li>
          <li className="list-group-item bg-transparent border-0 p-0"><a href="#" className="rajdhani-600 text-gray-100 font-sm">How to Integrate</a></li>
        </ul>
      </div>
      <div className="col-lg-2 col-md-4 col-6 lg-mt-3 ">
        <h4 className="text-white h6 rajdhani-700 mb-4 mt-1 text-uppercase">Company</h4>
        <ul className="list-group gap-2">
          <li className="list-group-item bg-transparent border-0 p-0"><a href="#" className="rajdhani-600 text-gray-100 font-sm">About us</a></li>
          <li className="list-group-item bg-transparent border-0 p-0"><a href="#" className="rajdhani-600 text-gray-100 font-sm">Careers</a></li>
          <li className="list-group-item bg-transparent border-0 p-0"><a href="#" className="rajdhani-600 text-gray-100 font-sm">Terms of use</a></li>
          <li className="list-group-item bg-transparent border-0 p-0"><a href="#" className="rajdhani-600 text-gray-100 font-sm">Privacy Policy</a></li>
        </ul>
      </div>
      <div className="col-lg-2 col-md-3 col-6 lg-mt-3 ms-auto">
        <h4 className="text-white h6 rajdhani-700 mb-4 mt-1 text-uppercase">Support</h4>
        <ul className="list-group gap-2">
          <li className="list-group-item bg-transparent border-0 p-0"><a href="#" className="rajdhani-600 text-gray-100 font-sm">Customer Support</a></li>
          <li className="list-group-item bg-transparent border-0 p-0"><a href="#" className="rajdhani-600 text-gray-100 font-sm">FAQ</a></li>
          <li className="list-group-item bg-transparent border-0 p-0"><a href="#" className="rajdhani-600 text-gray-100 font-sm">Integrations</a></li>
          <li className="list-group-item bg-transparent border-0 p-0"><a href="#" className="rajdhani-600 text-gray-100 font-sm">Tutorials</a></li>
        </ul>
      </div>
      <div className="col-lg-2 col-md-3 col-6 lg-mt-3">
        <h4 className="text-white h6 rajdhani-700 mb-4 mt-1 text-uppercase">Resources & Legal</h4>
        <ul className="list-group gap-2">
          <li className="list-group-item bg-transparent border-0 p-0"><a href="#" className="rajdhani-600 text-gray-100 font-sm">Blog</a></li>
          <li className="list-group-item bg-transparent border-0 p-0"><a href="#" className="rajdhani-600 text-gray-100 font-sm">Cookie Policy</a></li>
          <li className="list-group-item bg-transparent border-0 p-0"><a href="#" className="rajdhani-600 text-gray-100 font-sm">Privacy Policy</a></li>
          <li className="list-group-item bg-transparent border-0 p-0"><a href="#" className="rajdhani-600 text-gray-100 font-sm">Terms of Use</a></li>
        </ul>
      </div>
      <div className="col-12 border-dark border-top mt-50">
        <p className="py-4 text-center rajdhani-600 text-gray-100 font-sm mb-0">© 2023 Avatar Lab copyright.</p>
      </div>
    </div>
  </div>
</div>

  )
}
